export const newProjectPickerState = (root, overrides = {}) => ({
  open: true,
  tab: 'featured',
  templateId: 'blank',
  templateProject: null,
  projectType: 'website',
  ownerSlug: root?.userSlug || root?.activeWorkspace || root?.slug || null,
  name: '',
  creating: false,
  error: null,
  _libList: null,
  _libQuery: '',
  ...overrides
})

// FA207 / frank trap — a plain arrow (no `this`), so its call into the
// sibling export `newProjectPickerState` is inlined as a self-contained
// local rather than `this.call(...)` (project_frank_drops_module_local_helpers).
export const openNewProjectPickerModal = (el, root, overrides) => {
  const state = {
    open: true,
    tab: 'featured',
    templateId: 'blank',
    templateProject: null,
    projectType: 'website',
    ownerSlug: root?.userSlug || root?.activeWorkspace || root?.slug || null,
    name: '',
    creating: false,
    error: null,
    _libList: null,
    _libQuery: '',
    ...overrides
  }
  root?.update({ newProjectPicker: state })
  // MODAL-X-OVERFLOW-1: openCustomModal supplies a safe default maxHeight
  // ('90vh'), which the raw `openModal({ template: 'custom' })` layer does
  // not — without it ModalWindow has no outer scroll containment and the
  // ModalHeader holding the Close X is pushed off-screen on a short viewport.
  el.call('openCustomModal', {
    id: 'newProjectPicker',
    width: '670px',
    content: { extends: 'NewProjectPickerBody' },
    onClose: () => root?.update({ newProjectPicker: { open: false } })
  })
}
